module.exports = __webpack_public_path__ + "static/banner-87e2d897cd27a7dbbdf57f53dc7a0693.png";